import { updateProfile } from '@/apis/experience/interaction';

import { peekAff } from './aff-session';

export const flushRegisterAff = async () => {
  const aff = peekAff();

  if (!aff) {
    return;
  }

  await updateProfile({ type: 'extraProfile', values: { aff } });
};
